import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { DocumentEditor } from "@onlyoffice/document-editor-react";

import { generateTokenAsync } from "state/slices/template";
import SpinnerIcon from "../Icons/SpinnerIcon";
import useFullscreenToggle from "hooks/useFullscreenToggle";
import { comment } from "postcss/lib/postcss";

const defaultPermissions = {
  download: true,
  print: true,
  comment: false,
  review: false,
};

function OnlyOfficeDocumentEditor(props) {
  const {
    url,
    editorKey,
    userFullName,
    userId,
    companyId,
    renderSummary = false,
    SummaryOfArticles = <></>,
    id = "Editor",
    documentType = "word",
    width = "100%",
    fileType = "docx",
    title = "Articles of Association.docx",
    mode = "edit",
    zoom = -2, // fitting the document page width to the editor page
    containerHeight = "850px",
    showFullScreenToggle = true,
    permissions = {},
    onDocumentReady = () => null,
    onLoadComponentError = () => null,
    onDocumentStateChange = () => null,
    onError = () => null,
    handleSave = () => { },
    addCallbackUrl = true,
    metadata = {},
  } = props;

  //Generate a query string from the metadata object
  const query = Object.keys(metadata)
    .map((key) => `${key}=${metadata[key]}`)
    .join("&");

  const [token, setToken] = useState(null);
  const {
    isFullscreen,
    documentEditorHeight,
    ToggleFullscreenContainer,
    ToggleFullscreenButton,
  } = useFullscreenToggle(
    renderSummary ? "right-2/4 pl-4" : "",
    !showFullScreenToggle ? "900px" : containerHeight
  );
  const role = Cookies.get("role");

  const height =
    props.height && !isFullscreen ? props.height : documentEditorHeight;

  const config = useMemo(
    () => ({
      documentType,
      height,
      width,
      document: {
        fileType,
        key: `${editorKey}`,
        title,
        url,
        permissions: {
          ...defaultPermissions,
          ...permissions,
        },
      },

      editorConfig: {
        callbackUrl: addCallbackUrl
          ? `${process.env.REACT_APP_BASE_API_URL}/api/templates/track-changes?${query}`
          : "",

        // callbackUrl: addCallbackUrl
        //   ? `https://c337-41-242-3-107.ngrok-free.app/api/templates/track-changes?${query}`
        //   : "",
        mode,

        user: {
          // Defines the user currently viewing or editing the document
          name: userFullName,
          id: `${userId}-${role}-${companyId}`,
        },
        customization: {
          customer: {},
          anonymous: {
            request: false,
          },
          autosave: true,
          logo: {
            image:
              "https://sfl-bucket.s3.us-west-2.amazonaws.com/transparent.png",
          },
          uiTheme: "theme-classic-light",
          feedback: false,
          //forcesave: true,
          help: false,
          zoom,
          review: {
            showReviewChanges: false,
            hideReviewDisplay: true,
          },
          showComments: false,
          showRulers: false,
        },
      },
    }),
    [height]
  );

  const dispatch = useDispatch();

  useEffect(() => {
    async function generateToken() {
      const response = await dispatch(generateTokenAsync({ data: config }));
      setToken(response.payload.token);
    }
    generateToken();
  }, [config]);

  if (!token) {
    return (
      <div className="flex justify-center mx-auto mt-10 text-white">
        <SpinnerIcon className="text-gray-800" />
      </div>
    );
  }
  return (
    <ToggleFullscreenContainer>
      {showFullScreenToggle && <ToggleFullscreenButton />}
      <DocumentEditor
        id={id}
        documentServerUrl={
          process.env.REACT_APP_ONLY_OFFICE_DOCUMENT_SERVER_URL
        }
        config={{
          ...config,
          token,
        }}
        events_onDocumentReady={onDocumentReady}
        onLoadComponentError={(errorCode, errorDescription) => {
          onLoadComponentError(errorCode, errorDescription);
        }}
        events_onDocumentStateChange={(event) => {
          onDocumentStateChange(event);
        }}
        events_onError={(events_onError) => {
          onError(events_onError);
        }}
        events_onRequestSaveAs={handleSave}
      />
      {renderSummary && isFullscreen && (
        <div
          className={`${isFullscreen
            ? `fixed inset-0 ${renderSummary ? "left-2/4" : ""
            } top-[7.5rem] z-50`
            : "w-full min-h-[900px]"
            } overflow-auto text-left bg-white px-6`}
        >
          <SummaryOfArticles />
        </div>
      )}
    </ToggleFullscreenContainer>
  );
}

export default React.memo(OnlyOfficeDocumentEditor);
